export {QuickPurchaseModule} from './quickPurchaseModule';
